import classNames from 'classnames'
import { ReactNode, KeyboardEvent } from 'react'

interface CardProps {
  children: ReactNode
  className?: string
  onClick?: () => void
  onMouseEnter?: () => void
  onMouseLeave?: () => void
  onKeyDown?: (e: KeyboardEvent<HTMLDivElement>) => void
  role?: string
  tabIndex?: number
  'aria-label'?: string
}

const Card = ({
  children,
  className,
  onClick,
  onMouseEnter,
  onMouseLeave,
  onKeyDown,
  role,
  tabIndex,
  'aria-label': ariaLabel,
}: CardProps) => {
  return (
    <div
      role={role}
      tabIndex={tabIndex}
      aria-label={ariaLabel}
      onClick={onClick}
      onKeyDown={onKeyDown}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className={classNames(
        'flex flex-col overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm',
        className
      )}
    >
      {children}
    </div>
  )
}

export default Card
